export default __webpack_public_path__ + "static/media/2SideMarket.372562f1.png";